import React from 'react'
import BackButtonButton from './BackButton'
import NextStepButton from './NextStepButton'
import {BlockComponentProps} from '../index'
import {usePurchaseForm} from './PurchaseFormProvider'
import CountrySelect from '../../lib/ui/CountrySelect'
import StateSelect from '../../lib/ui/StateSelect'
import {PurchaseFormBlock} from '.'
import {useSection} from '../../Section'
import Checkbox from '../../lib/ui/CheckBox'
import styles from './PurchaseForm.module.css'
import {usePurchase} from '../../PurchaseContext'
import {ErrorBox} from '../PurchaseForm/CustomerDetailStep'

interface BillingAddressStepProps extends PurchaseFormBlock {
  onBack: () => void
  onContinue: () => void
  TextFieldComponent: React.FC<any>
  ButtonComponent: React.FC<any>
}

export default function BillingAddressStep(
  props: BillingAddressStepProps & BlockComponentProps,
) {
  const {
    onBack,
    onContinue,
    TextFieldComponent,
    ButtonComponent,
    ...config
  } = props
  const {
    buttonsAlignment,
    input: {spacing},
    buttonStyle,
  } = config

  const {
    useSameAddressForShipping,
    setUseSameAddressForShipping,
    validateBillingForm,
    billingAddress1Error,
    billingCountryIdError,
    billingStateIdError,
    billingCityError,
    billingZipPostalError,
    hasError,
    ...form
  } = usePurchaseForm()

  const {calculateVisibility} = useSection()
  const {selectedTicket} = usePurchase()

  const handleContinue = async () => {
    const valid = selectedTicket?.billing_address_required
      ? validateBillingForm(config)
      : true
    if (valid) {
      onContinue()
    } else {
      calculateVisibility()
    }
  }

  return (
    <div>
      <div>
        <TextFieldComponent
          aria-label={`billing_address address 1`}
          config={config}
          placeholder={'billingAddress1'}
          value={form.billingAddress1}
          onChange={(e: any) => form.setBillingAddress1(e)}
          error={!!billingAddress1Error}
        />
      </div>
      <div>
        <TextFieldComponent
          aria-label={`billing_address address 2`}
          config={config}
          placeholder={'billingAddress2'}
          value={form.billingAddress2}
          onChange={(e: any) => form.setBillingAddress2(e)}
        />
      </div>
      <div>
        <CountrySelect
          config={config}
          value={form.billingCountryId}
          onChange={(value) => form.setBillingCountryId(value)}
          defaultLabel={config.input.placeholder.country}
          error={!!billingCountryIdError}
        />
      </div>
      <div>
        <StateSelect
          config={config}
          value={form.billingStateId}
          onChange={(value) => form.setBillingStateId(value)}
          countryId={form.billingCountryId}
          defaultLabel={config.input.placeholder.state}
          error={!!billingStateIdError}
        />
      </div>
      <div>
        <TextFieldComponent
          aria-label={`billing_address city`}
          config={config}
          placeholder={'city'}
          value={form.billingCity}
          onChange={(e: any) => form.setBillingCity(e)}
          error={!!billingCityError}
        />
      </div>
      <div>
        <TextFieldComponent
          aria-label={`billing_address postal`}
          config={config}
          placeholder={'zipcode'}
          value={form.billingZipPostal}
          onChange={(e: any) => form.setBillingZipPostal(e)}
          error={!!billingZipPostalError}
        />
      </div>

      {selectedTicket?.shipping_address_enabled && (
        <div style={{marginBottom: 10}}>
          <Checkbox
            aria-label="shipping same as billing"
            color={config.input.textColor}
            onChange={() =>
              setUseSameAddressForShipping(!useSameAddressForShipping)
            }
            checked={useSameAddressForShipping}
            label={props.questions.sameShippingAddress}
          />
        </div>
      )}

      <ErrorBox showError={hasError} config={config} />
      <div
        className={styles.formButtonBox}
        style={{
          gap: '15px',
          marginTop: spacing,
          justifyContent: buttonsAlignment,
          alignItems: 'stretch',
        }}
      >
        <BackButtonButton {...config} onClick={onBack} />
        <div
          className={styles.purchaseFormButtonHolder}
          style={{width: buttonStyle.width + '%'}}
        >
          <NextStepButton
            ButtonComponent={ButtonComponent}
            {...config}
            onClick={handleContinue}
          />
        </div>
      </div>
    </div>
  )
}
